<div class="h-full">
    <app-ongletlayout
        storageId="comptabilite"
        [ongletLinks]="tableLinkForComptabilite"
    >
        <div class="border">
            <router-outlet></router-outlet>
        </div>
    </app-ongletlayout>
</div>